module.exports = __webpack_public_path__ + "static/media/Benifits3.e568f301.png";